import { Link } from 'react-router-dom';
import { serviceCategories } from '@/mocks/services';

export default function ServiceOverview() {
  return (
    <section className="w-full py-14 md:py-20 bg-background-50">
      <div className="max-w-7xl mx-auto px-4 md:px-6">
        <div className="text-center mb-10 md:mb-14">
          <h2 className="text-2xl md:text-3xl font-heading font-bold text-foreground-950">
            我们的服务
          </h2>
          <p className="mt-3 text-sm md:text-base text-foreground-600 max-w-lg mx-auto">
            从发型到妆容，从护肤到美甲，一站式满足你的美丽需求
          </p>
        </div>

        <div className="grid grid-cols-2 sm:grid-cols-3 lg:grid-cols-6 gap-3 md:gap-4">
          {serviceCategories.filter(c => c.id !== 'all').map((category) => (
            <Link
              key={category.id}
              to={`/services/${category.slug}`}
              className="group flex flex-col items-center gap-3 p-4 md:p-5 rounded-lg bg-background-100 hover:bg-primary-50 transition-colors duration-200 cursor-pointer"
            >
              <div className="w-12 h-12 md:w-14 md:h-14 rounded-full bg-accent-100 flex items-center justify-center group-hover:bg-accent-200 transition-colors duration-200">
                <i className={`${category.icon} text-xl md:text-2xl text-accent-600`} />
              </div>
              <span className="text-xs md:text-sm font-medium text-foreground-800 whitespace-nowrap">
                {category.name}
              </span>
            </Link>
          ))}
        </div>

        <div className="mt-8 text-center">
          <Link
            to="/services"
            className="inline-flex items-center gap-1.5 text-sm text-primary-500 hover:text-primary-600 font-medium cursor-pointer transition-colors whitespace-nowrap"
          >
            查看全部服务
            <i className="ri-arrow-right-line" />
          </Link>
        </div>
      </div>
    </section>
  );
}